module.exports = __webpack_public_path__ + "static/media/uw_thumbnail.7bd867dd.png";